import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import '../../../index.css';

const fallbackChartData = [
  { day: "01", value: 700 },
  { day: "02", value: 450 },
  { day: "03", value: 700 },
  { day: "04", value: 450 },
  { day: "05", value: 700 },
  { day: "06", value: 450 },
  { day: "07", value: 700 },
  { day: "08", value: 450 },
  { day: "09", value: 700 },
  { day: "10", value: 450 },
  { day: "11", value: 700 },
  { day: "12", value: 450 },
  { day: "13", value: 700 },
  { day: "14", value: 450 },
  { day: "15", value: 700 },
];

const VoicemailVolumeChart = ({ chartData = fallbackChartData }) => {
  // Transform data for MUI charts
  const xAxisData = chartData.map((item) => item.day);
  const seriesData = chartData.map((item) => item.value);
  const maxSeriesValue = Math.max(0, ...seriesData);
  const dynamicYAxisMax =
    maxSeriesValue <= 10
      ? 10
      : Math.ceil(maxSeriesValue * 1.2);

  return (
    <div className="bg-white rounded-xl shadow-sm py-6 sm:p-6 border border-line">
      {/* Header */}
      <div className="mb-6 pb-4 border-b border-line px-6 sm:px-0">
        <h2 className="text-lg font-bold text-content mb-1">
          Voicemail Volume
        </h2>
        <p className="text-sm text-subtle">
          Daily transcription count for the last 15 days
        </p>
      </div>
      <div className="w-full -ml-5 " style={{ height: "300px" }}>
        <BarChart
          xAxis={[
            {
              id: "barCategories",
              data: xAxisData,
              scaleType: "band",
              tickLabelStyle: {
                fontSize: 12,
                fill: "#64748B",
              },
              tickLabelFormatter: (value, index) => {
                return value || xAxisData[index] || "";
              },
            },
          ]}
          yAxis={[
            {
              id: "valueAxis",
              min: 0,
              max: dynamicYAxisMax,
              tickLabelStyle: {
                fontSize: 12,
                fill: "#64748B",
              },
            },
          ]}
          series={[
            {
              data: seriesData,
              color: "#061C3D",
            },
          ]}
          width={undefined}
          height={300}
          sx={{
            "& .MuiChartsAxis-tick": {
              stroke: "#E2E8F0",
            },
            "& .MuiChartsAxis-line": {
              stroke: "#E2E8F0",
            },
            "& .MuiBarElement-root": {
              rx: 6,
              ry: 6,
            },
          }}
        />
      </div>
    </div>
  );
};

export default VoicemailVolumeChart;
